export default __webpack_public_path__ + "static/material_02-6c24ae899c6dd9ac83749006b0394da5.png";